var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4.9C6.6136 4.9 6.3 4.5864 6.3 4.2C6.3 3.8136 6.6136 3.5 7 3.5C7.3864 3.5 7.7 3.8136 7.7 4.2C7.7 4.5864 7.3864 4.9 7 4.9ZM7.70078 9.80156C7.70078 10.188 7.38718 10.5016 7.00078 10.5016C6.61438 10.5016 6.30078 10.188 6.30078 9.80156V6.30156C6.30078 5.91516 6.61438 5.60156 7.00078 5.60156C7.38718 5.60156 7.70078 5.91516 7.70078 6.30156V9.80156ZM7 0C3.1339 0 0 3.1339 0 7C0 10.8661 3.1339 14 7 14C10.8654 14 14 10.8661 14 7C14 3.1339 10.8654 0 7 0Z",
    fill: "#073041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.b1ca9c4641ba80aa2eff657a3a5771a8.svg";
export { ForwardRef as ReactComponent };